/* src/app/home/home.component.css */
.link {
  font-size: 30px;
  display: inline-block;
  margin-top: 15px;
  margin-bottom: 10px;
  margin-right: 10px;
}
.textDisplay {
  height: 250px;
  overflow: hidden;
  margin-bottom: 10px;
}
/*# sourceMappingURL=home.component.css.map */
